module.exports = fox._r("images/about-placeholder.gif", __webpack_public_path__ + "images/about-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// ./images/about-placeholder.gif
// module id = 10
// module chunks = 4